var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseaccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7V16.0858L15.5 17.5858L13.9899 16.0757C13.4432 15.529 12.5568 15.529 12.0101 16.0757L10.4386 17.6472L8.39626 15.9452C7.87707 15.5125 7.12293 15.5125 6.60374 15.9452L4.56137 17.6472L3 16.0858L3 2H12V6C12 6.55228 12.4477 7 13 7H17ZM18 6V7V16.0858C18 16.351 17.8946 16.6054 17.7071 16.7929L15.7828 18.7172C15.6266 18.8734 15.3734 18.8734 15.2172 18.7172L13.2828 16.7828C13.1266 16.6266 12.8734 16.6266 12.7172 16.7828L10.7583 18.7417C10.612 18.888 10.3783 18.8986 10.2194 18.7661L7.75607 16.7134C7.60774 16.5898 7.39226 16.5898 7.24393 16.7134L4.78062 18.7661C4.62169 18.8986 4.38799 18.888 4.2417 18.7417L2.29289 16.7929C2.10536 16.6054 2 16.351 2 16.0858V2C2 1.44772 2.44772 1 3 1H12H12.6134H13V1.07776C13.1042 1.12142 13.2011 1.18279 13.2861 1.26006L17.6727 5.24788C17.8811 5.43741 18 5.70608 18 5.98782V6ZM13 2.35146L17 5.98782V6H13V2.35146Z",
    fill: "#74A3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseaccount);
export default __webpack_public_path__ + "static/media/closeaccount.061e63c56a42e24c990dd83f0ac8cf67.svg";
export { ForwardRef as ReactComponent };